import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { CounterCustomerChargeMaintenanceProvider } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { CounterCustomerChargeMasterView } from "presentation/view/section/CounterCustomerCharge/CounterCustomerChargeMasterView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const CounterCustomerChargeMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.COUNTER_CUSTOMER_CHARGE_MAINTENANCE}>
        <MessageBarWrapper>
            <CounterCustomerChargeMaintenanceProvider>
                <GridStyles/>
                <CounterCustomerChargeMasterView/>
            </CounterCustomerChargeMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default CounterCustomerChargeMaintenanceCont;